import React, { PropsWithChildren } from 'react';

import MicrophonePermissionRequest from 'features/Chat/components/MicrophonePermissionRequest';

import { useSettingsService } from './hooks';

const Settings: React.FC<PropsWithChildren> = ({ children }) => {
  const { microphoneAccess, isBrowserSupported } = useSettingsService();

  if (microphoneAccess === 'granted' && isBrowserSupported) {
    return <>{children}</>;
  }

  return <MicrophonePermissionRequest onDismiss={() => {}} />;
};

export default Settings;
